import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionLabel } from "@/components/primitives";
import CorporateInfoCard from "@/components/CorporateInfoCard";
import { credibility } from "@/data/content";

export default function AboutSection() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="border-t border-fs-border bg-fs-bg2 py-24 lg:py-32"
    >
      <div className="fs-shell">
        <div className="grid gap-16 lg:grid-cols-12">
          {/* Left */}
          <div className="lg:col-span-6">
            <Reveal>
              <SectionLabel testId="about-label">About Us</SectionLabel>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 fs-h2">
                Built by Fortunastrive
                <br className="hidden sm:block" /> Services Private Limited.
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 max-w-xl fs-body">
                Fortunastrive Services Private Limited is a consulting and systems
                implementation company helping service businesses improve how they
                position, market, automate, and operate.
              </p>
            </Reveal>

            <StaggerGroup className="mt-12 grid gap-8 sm:grid-cols-2">
              {credibility.map((c) => {
                const Icon = c.icon;
                return (
                  <StaggerItem key={c.title}>
                    <div data-testid={`credibility-${c.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                      <Icon className="h-5 w-5 text-fs-gold" strokeWidth={1.4} />
                      <h3 className="mt-4 font-serif text-xl text-fs-ink">{c.title}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-fs-muted">{c.desc}</p>
                    </div>
                  </StaggerItem>
                );
              })}
            </StaggerGroup>
          </div>

          {/* Right — corporate details */}
          <div className="lg:col-span-6">
            <Reveal delay={0.2}>
              <CorporateInfoCard />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
